export default {
	"passwordInput.reveal.off": "Passwort anzeigen",
	"passwordInput.reveal.on": "Passwort verstecken",
} as const;
